import { useRef } from 'react'
import dynamic from 'next/dynamic'
import { GlobalStyle as GingaGlobalStyle, RebrandToggle } from '@dlpco/ginga-stone'
import { ThemeProvider } from 'styled-components'

import { useContaTheme } from '../hooks/use-conta-theme'
import { GlobalStyle } from '../lib/global-style'

import '@stone-payments/jade-design-tokens/stone/bundle.css'
import '@stone-payments/jade-design-tokens/stone-rebrand/theme.css'
import '@stone-payments/jade/css/index.css'

const JadeProvider = dynamic(() => import('@stone-payments/jade').then(mod => mod.JadeProvider), { ssr: false })

export const ThemeProviders = ({ children }: { children: React.ReactNode }) => {
  const theme = useContaTheme()
  const portalRef = useRef<HTMLDivElement>(null)

  return (
    <JadeProvider theme="stone-rebrand" portalRoot={portalRef}>
      <div ref={portalRef} data-testid="portal-root" />
      <RebrandToggle rebrand={true}>
        <GlobalStyle contaTheme={theme} />
        <GingaGlobalStyle />
        <ThemeProvider theme={theme}>{children}</ThemeProvider>
      </RebrandToggle>
    </JadeProvider>
  )
}
